import React from "react";
import {useTranslation} from "react-i18next";
import i18n from "i18next";
import {buildInteractionParam} from "../pages/utils";

const PrintDgis = ({patGenes}) => {
  const {t} = useTranslation();

  return (
    <div style={{ textAlign: "left"}}>
      <h2 style={{ color: "#1565a0"}}>{ t("critical_medicines_and_recommendations")}</h2>
      {patGenes?.length > 0 &&
        patGenes?.map ((gene, i) => {
          return (
            <div key={`gene${i} recommendation`}>
              <h3 style={ {color: "#1565a0"}}>
                { t("gene_name") }: {gene?.geneName} ({ t("phenotype") }: {t(gene?.phenotype)})
              </h3>
              {gene?.risks?.length
                ?
                gene?.risks?.map((risk, j) => {
                  let substance = JSON.parse(risk?.recommendation)[i18n.language?.toUpperCase()]?.substanceName;

                  if(substance === ""){
                    substance = risk.substanceKey;
                  }

                  return (
                    <div key={`risk${i}${j}recommendation`}>
                      <h4 style={ {color: "#1565a0", textDecoration: "underline"}}>{t("active_substance")}: {substance}</h4>
                      <div>
                        {t("recommendations_of_dpwg")}{": "}
                        {buildInteractionParam(risk?.recommendation, true)}
                      </div>
                    </div>
                  )
                })
                :<div>{t("no_risk")}</div>
              }
            </div>
          )
        })
      }
    </div>
  )
}

export default PrintDgis;